export default __webpack_public_path__ + "static/media/ui.a5c24515.png";